/**
 * axios setup to use mock service
 */

import axios from 'axios';

const axiosInstance = axios.create();

axiosInstance.CancelToken = axios.CancelToken;
axiosInstance.isCancel = axios.isCancel;

export default axiosInstance;
